import { useState } from "react";
import { useDispatch } from "react-redux";
import { putAlertObsoletereadCountSlice } from "../../../redux/actions/putAlertObsoletereadCountSlice";
import {
    putAlertImmutableauditreadCountEndpoint,
    putAlertObsoletereadCountEndpoint,
    putBuyerForecastHistoryNotificationsReadEndpoint,
} from "../../../common/endpoints";
import { putAlertImmutableauditreadCountSlice } from "../../../redux/actions/putAlertImmutableauditreadCountSlice";
import { putBuyerForecastHistoryNotificationsReadSlice } from "../../../redux/actions/putBuyerForecastHistoryNotificationsReadSlice";

const cellStyle = {
    padding: "8px",
    border: "1px solid #e0e0e0",
    fontSize: "13px",
    textAlign: "left",
};

const AlertCards = ({ alertData }) => {
    const [expanded, setExpanded] = useState(false);
    const [read, setRead] = useState(!(alertData?.status === "UNREAD" || alertData?.isNew === true));
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleShowMore = async () => {
        try {
            setExpanded(!expanded);

            if (!read) {
                setLoading(true);

                const userEmail = localStorage.getItem("userEmail");
                const id = alertData?.id;

                let response;

                if (alertData?.type === "obsolete") {
                    response = await dispatch(
                        putAlertObsoletereadCountSlice({
                            dynamicEndpoint: `${putAlertObsoletereadCountEndpoint}/${id}/read/${userEmail}`,
                        })
                    );
                } else if (alertData?.type === "notification") {
                    response = await dispatch(
                        putAlertImmutableauditreadCountSlice({
                            dynamicEndpoint: `${putAlertImmutableauditreadCountEndpoint}/${id}/read/${userEmail}`,
                        })
                    );
                } else if (alertData?.type === "forecastHistory") {
                    response = await dispatch(
                        putBuyerForecastHistoryNotificationsReadSlice({
                            dynamicEndpoint: `${putBuyerForecastHistoryNotificationsReadEndpoint}/${id}/read/${encodeURIComponent(userEmail)}`,
                            skipUserEmailParam: true,
                        })
                    );
                }

                if (response?.meta?.requestStatus === "fulfilled") {
                    setRead(true);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "relative",
                background: "#EAF2FB",
                borderLeft: "4px solid #1976d2",
                padding: "12px",
                borderRadius: "6px",
                marginBottom: "12px",
            }}
        >
            {/* TOP ROW */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                    {alertData?.type === "obsolete" ? alertData?.title : alertData?.title}
                </div>

                {/* NEW badge */}
                {!read && (
                    <div
                        style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "#ef4444",
                            color: "#fff",
                            fontSize: "10px",
                            fontWeight: 700,
                            padding: "2px 6px",
                            borderRadius: "999px",
                        }}
                    >
                        NEW
                    </div>
                )}

                <div style={{ fontSize: "16px", color: "#333" }}>
                    {alertData?.type === "obsolete" ? alertData?.alertDate?.split("T")[0] :
                        alertData?.alertDate?.split("T")[0]
                    }
                </div>
            </div>

            {alertData?.type === "notification" && <div style={{ marginTop: 10, fontSize: "16px" }}>
                Dear Planner,
                <br />
                <br />
                We are pleased to inform you that the latest forecast has now been <strong>confirmed</strong> and is available for your review.
            </div>}

            {alertData?.type === "forecastHistory" && (
                <div style={{ marginTop: 10, fontSize: "16px", whiteSpace: "pre-line" }}>
                    <div dangerouslySetInnerHTML={{ __html: alertData?.description || "Forecast history export is available in My Downloads." }} />
                    
                </div>
            )}


            {/* DESCRIPTION */}
            <div style={{ marginTop: 10, fontSize: "16px" }}>
                {alertData?.type === "obsolete" && alertData?.description}
            </div>

            {/* TABLE */}
            {expanded && (
                <div style={{ marginTop: 12 }}>
                    {alertData?.type === "obsolete" ? (
                        <table
                            style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                background: "#fff",
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={cellStyle}>Plant Code</th>
                                    <th style={cellStyle}>Material ID</th>
                                    <th style={cellStyle}>Material Description</th>
                                    <th style={cellStyle}>External Material Group</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={cellStyle}>{alertData?.plant}</td>
                                    <td style={cellStyle}>{alertData?.material}</td>
                                    <td style={cellStyle}>{alertData?.materialDescription}</td>
                                    <td style={cellStyle}>{alertData?.externalMaterialGroup}</td>
                                </tr>
                            </tbody>
                        </table>
                    ) : alertData?.type === "forecastHistory" ? (
                        <div
                            style={{
                                fontSize: "16px",
                            }}
                        >
                            
                            {alertData?.downloadUrl && (
                                <div style={{ marginTop: 10 }}>
                                    <a
                                        href={alertData.downloadUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1976d2", textDecoration: "underline", fontWeight: 600 }}
                                    >
                                        Download Export File
                                    </a>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div
                            style={{
                                fontSize: "16px",
                            }}
                        >
                            {alertData?.description}
                            {alertData?.type === "notification" && <div style={{ marginTop: 10, fontSize: "16px" }}>
                                Kindly review the confirmed forecast and proceed with the necessary planning actions.
                            </div>}
                        </div>

                    )}
                </div>
            )}

            {/* SHOW MORE / LESS */}
            <div
                onClick={handleShowMore}
                style={{
                    marginTop: 16,
                    marginBottom: 6,
                    color: "#1976d2",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: 500,
                    opacity: loading ? 0.6 : 1,
                }}
            >
                {expanded ? "Show Less" : "Show More"}
            </div>
        </div>
    );
};

export default AlertCards;